export default "__VITE_ASSET__BJM0arue__"